import React, { useState } from 'react';
import _ from 'lodash';

import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import ClickAwayListener from '@mui/material/ClickAwayListener';

import { ROLE_LIST } from '../../constants/global';
import useUserAuth from '../../hook/useUserAuth';
import Logout from './Logout';

import { TopbarButton, UserPaperStyle } from './topbarStyle';
import { AccountCircleOutlinedIcon, KeyboardArrowDownOutlinedIcon } from '../customStyles/images';
import theme from '../../theme';


const UserProfile = (props) => {
  const { userAuth, setUserAuth, authStatusMsg, setAuthStatusMsg } = useUserAuth();
  const { isDesktop, isMobile } = props;

  const [target, setTarget] = useState(null);
  const isOpen = Boolean(target);

  const handleMenuOpen = (e) => {
    setTarget(e.currentTarget);
  };

  const handleMenuClose = () => {
    setTarget(null);
  };

  return (
    <>
      {
        isDesktop &&
        <>
          <TopbarButton
            startIcon={<AccountCircleOutlinedIcon variant='md_24' />}
            endIcon={<KeyboardArrowDownOutlinedIcon />}
            onClick={handleMenuOpen}
          >
            {userAuth?.name ? userAuth.name : 'User'}
          </TopbarButton>

          <Popper
            open={isOpen}
            anchorEl={target}
            placement='bottom-end'
            style={{ zIndex: 2000 }}
          >
            <ClickAwayListener onClickAway={handleMenuClose}>
              <Paper
                style={UserPaperStyle}
                sx={{ py: 1, pt: '12px' }}
              >
                <Stack
                  variant='center-start'
                  sx={{ pl: 2, pr: 2 }}
                >
                  <Box mt={1}>
                    <AccountCircleOutlinedIcon variant='lg_40' />
                  </Box>

                  <Box ml={1} sx={{ marginTop: '6px' }}>
                    <Typography variant='h5'>{userAuth?.name ? userAuth.name : 'User'}</Typography>

                    <Typography variant='h6' color='grey'>{userAuth?.email ? userAuth.email : '已登入'}</Typography>

                    {/* <Box mt={1}>
                      <Chip variant='text-grey' label={userRoleName} />
                    </Box> */}

                  </Box>
                </Stack>

                <Divider sx={{ mt: 1.5, mb: 1 }} />

                <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
                  <Logout variant="desktop" />
                </Box>

              </Paper>
            </ClickAwayListener>
          </Popper>
        </>
      }

      {
        isMobile &&
        <>
          <Stack variant='between-center'>
            <Stack variant='center-center' mt={2}>
              <AccountCircleOutlinedIcon variant='lg_48' />
              <Box ml={1}>
                <Typography
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 600,
                  }}
                >
                  {userAuth?.name ? userAuth.name : 'User'}
                </Typography>

                <Typography variant='h6' color='grey'>{userAuth?.email ? userAuth.email : '已登入'}</Typography>

                {/* <Box mt={1}>
                  <Chip variant='text-grey' label={userRoleName} />
                </Box> */}

              </Box>
            </Stack>

          </Stack>
        </>
      }
    </>
  )
}

export default UserProfile;